import Cookies from "js-cookie";

const USER = "user";
const TOKEN = "token";
const WIDGETS = "widgets";

export const setUser = (data) => {
  Cookies.set(USER, JSON.stringify(data));
};

export const setUserCookie = (data) => {
  Cookies.set(USER, JSON.stringify(data));
};

export const getUser = () => {
  const user = Cookies.get(USER);
  if (user) return JSON.parse(user);
  return user;
};

export const getUserCookie = () => {
  const user = Cookies.get(USER);
  if (user) return JSON.parse(user);
  return user;
};

export const setToken = (data) => {
  Cookies.set(TOKEN, data);
};

export const setTokenCookie = (data) => {
  Cookies.set(TOKEN, data);
};

export const getToken = () => {
  return Cookies.get(TOKEN);
};

export const getTokenCookie = () => {
  return Cookies.get(TOKEN);
};

export const setWidgetsCookie = (data) => {
  Cookies.set(WIDGETS, JSON.stringify(data));
};

export const getWidgetsCookie = () => {
  let value = Cookies.get(WIDGETS) || "[]";
  return JSON.parse(value);
};

export const removeAll = () => {
  Object.keys(Cookies.get()).forEach(function (cookieName) {
    Cookies.remove(cookieName);
  });
};

export const setCookie = (key, data) => {
  if (typeof data === "object") data = JSON.stringify(data);
  Cookies.set(key, data);
};

export const getCookie = (key) => {
  return Cookies.get(key);
};
